import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiSpacer } from "@elastic/eui";
import TableOfContent from "components/Outdoor_Cameras/IN-9408_WQHD/Quick_Installation/ToC/TableOfContent";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  TableOfContent,
  BreadCrumbs,
  SEOHelmet,
  React
};